import { gql } from '@apollo/client';

export type Campaign = {
  id: string;
  name: string;
};

export const fetchCampaignsQuery = gql`
  query getCampaigns(
    $campaignFilterInfo: CampaignFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    campaigns(
      campaignFilterInfo: $campaignFilterInfo
      pagination: $pagination
      sort: $sort
      search: $search
    ) {
      results {
        id
        name
        messageMedium
      }
    }
  }
`;

export const parseCampaignsResponse = (resp: unknown): Campaign[] | undefined =>
  (resp as any)?.campaigns?.results;

export const fetchCampaignQuery = gql`
  query getCampaign($id: Long!) {
    campaign(id: $id) {
      name
      id
    }
  }
`;

export const parseCampaignResponse = (resp: unknown): Campaign | undefined =>
  (resp as any)?.campaign;
